import produce from "immer";
import { IStoreState } from "..";
import { LoadState } from "../../constants/enums";
import { TaskListActions } from ".";
import { initialTaskListState } from "./defaultState";
import {
  CLEAR_SINGLE_TASK_LIST_ITEM,
  CLEAR_SUB_TASK_LIST_ITEM,
  CLEAR_TASK_LIST_ITEM,
  CLEAR_TASK_LIST_STATE,
  FETCH_PROJECT_TASK_LIST_FAILED,
  FETCH_PROJECT_TASK_LIST_PROGRESS,
  FETCH_PROJECT_TASK_LIST_SUCCESS,
  FETCH_SINGLE_TASK_FAILED,
  FETCH_SINGLE_TASK_PROGRESS,
  FETCH_SINGLE_TASK_SUCCESS,
  FETCH_SUB_TASK_LIST_FAILED,
  FETCH_SUB_TASK_LIST_PROGRESS,
  FETCH_SUB_TASK_LIST_SUCCESS,
  FETCH_TASK_LIST_FAILED,
  FETCH_TASK_LIST_PROGRESS,
  FETCH_TASK_LIST_SUCCESS,
  UPSERT_PROJECT_SUB_TASK_SUCCESS,
  UPSERT_PROJECT_TASK_SUCCESS,
} from "./taskListActions";

export const taskListReducer = (
  state: IStoreState["taskList"] = initialTaskListState,
  action: TaskListActions,
) => {
  switch (action.type) {
    case FETCH_TASK_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_TASK_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = data;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_TASK_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_PROJECT_TASK_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_PROJECT_TASK_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = data;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_PROJECT_TASK_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
      });
      return newState;
    }

    case UPSERT_PROJECT_TASK_SUCCESS: {
      const data = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = draftState.list.map((row) => {
          if (row.task_uuid === data.task_uuid) return data;
          return row;
        });
      });
      return newState;
    }
    case UPSERT_PROJECT_SUB_TASK_SUCCESS: {
      const data = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.subTaskList = draftState.subTaskList.map((row) => {
          if (row.task_uuid === data.task_uuid) return data;
          return row;
        });
      });
      return newState;
    }

    case FETCH_SUB_TASK_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.subTaskListLoading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_SUB_TASK_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.subTaskListLoading = LoadState.Loaded;
        draftState.subTaskList = data;
        draftState.subTaskListTotalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_SUB_TASK_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.subTaskListLoading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_SINGLE_TASK_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.TaskListLoading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_SINGLE_TASK_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.TaskListLoading = LoadState.Loaded;
        draftState.TaskListItem = data;
      });
      return newState;
    }
    case FETCH_SINGLE_TASK_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.TaskListLoading = LoadState.InProgress;
      });
      return newState;
    }
    case CLEAR_SINGLE_TASK_LIST_ITEM: {
      const newState = produce(state, (draftState) => {
        draftState.TaskListLoading = LoadState.NotLoaded;
        draftState.TaskListItem = initialTaskListState["TaskListItem"];
      });
      return newState;
    }
    case CLEAR_TASK_LIST_ITEM: {
      const newState = produce(state, (draftState) => {
        draftState.TaskListLoading = LoadState.NotLoaded;
        draftState.list = initialTaskListState["list"];
      });
      return newState;
    }
    case CLEAR_SUB_TASK_LIST_ITEM: {
      const newState = produce(state, (draftState) => {
        draftState.subTaskListLoading = LoadState.NotLoaded;
        draftState.subTaskList = initialTaskListState["subTaskList"];
      });
      return newState;
    }
    case CLEAR_TASK_LIST_STATE: {
      return initialTaskListState;
    }
    default: {
      return state;
    }
  }
};
